<template>
  <div id="app">
    <router-view v-if="flag"/>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import request from  '@/utils/request'
import config from './assets/config'
var class2type = {}
var hasOwn = class2type.hasOwnProperty 
function has (obj, path) {
  return obj != null && hasOwn.call(obj, path) && obj[path]
}
export default {
  name: 'App',
  data () {
    return {
      flag: false
    }
  },
  mounted () {
    document.title = config.title
    this.$store.commit('get_user_from_db')
    let token = '',rformname = '',parms='',parmskey=''
    if (has(this.$store.getters.loginUser, 'userid')) { 
      if (this.$store.getters.tabRoutes.length <= 0 && this.$store.getters.userMenus.length > 0) {
        let firstMenu = this.$store.getters.userMenus[0].children[0]
        // this.$router.push({path: firstMenu.path, query: {menuid: firstMenu.menuid}})
      }
      this.flag = true 
    } 
    // let m = {menuid: 27}
    // let rformname = 'comIndex'
    // // this.$router.push({name: rformname, params: m})
    // this.$store.commit('set_active_name', {name: rformname, params: m})
    if (location.search || !has(this.$store.getters.loginUser, 'userid')) {
      let parm = ''
      if (location.search.substr(1).indexOf('&') === -1) {
        token = location.search.substr(1).split('=')[1]
      } else {
        parm = location.search.substr(1).split('&')

        token = parm[0].split('=')[1]
        if (parm.length >= 1) {
          rformname = parm[1].split('=')[1]
        }
        if (parm.length >= 2) {
          parms = parm[2].split('=')[1]
          parmskey = parm[2].split('=')[0]
        }
      }
      // 地址栏无可解析 token 时，尝试取本会话已缓存的 token（应对刷新后 URL 已抹除的场景）
      if (!token) {
        token = window.sessionStorage.getItem('yzob_token') || window.localStorage.getItem('yzob_token') || ''
      }
      // 取出 token 后立即从地址栏抹除查询参数，避免残留 URL 被拷贝/记录导致越权操作
      if (token) {
        window.sessionStorage.setItem('yzob_token', token)
        window.localStorage.setItem('yzob_token', token)
        window.history.replaceState({}, '', location.pathname + location.hash)
      }
      axios({
        method:'post',
        url: `${config.baseUrl}token/tokenUser`,
        headers: {
          'Authorization': `Bearer ` + token
        }
      }).then(async res => {
        let {data} = res
        data.token = token
        if (data.code && data.code === 401) {
          alert('系统检测到账号登录状态异常。为保障业务数据安全，当前会话已终止，请立即重新登录；如非本人操作，请立即联系管理员。')
          window.location.href = `${config.webUrl}/#/login`
          return
        }
        this.$store.commit('set_user_info', data)
        this.flag = true
        if (rformname) {
          let m = {}
          m[parmskey] = parms
          this.$router.push({name: rformname, params: m})
          this.$store.commit('set_active_name', {name: rformname, params: m})
        }
        if (this.$store.getters.tabRoutes.length <= 0) {
          let firstMenu = this.$store.getters.userMenus[0].children[0]
        }
      }).catch(err => {
        alert('系统检测到账号登录状态异常。为保障业务数据安全，当前会话已终止，请立即重新登录；如非本人操作，请立即联系管理员。')
        window.location.href = (config.webUrl || '') + '/#/login'
      })
    }

  }
}
</script>

<style>
  @import "./assets/css/base.css"
</style>
